module.exports = __webpack_public_path__ + "static/media/collectionc-centre-cropped.f0d21aa0.jpg";